import $ from 'jquery';
import { getStorage } from '../../home24/helpers/storage-factory';
import * as registry from '../../home24/core/registry';
import * as config from '../../home24/core/config';

/**
 * This module supports FactFinder click tracking on search page
 * Event originates on search page, but request is sent on PDP to
 * minimize lag
 */
const storage = getStorage();

var self = {};

self.$scope = $('body');

self.trackingKey = 'factFinderTracking';

self.send = function (properties) {
    /*
     * Sanitize properties
     */
    var allowedProperties = config.get('tracking.factfinder.allowedProperties');

    for (var i in properties) { // eslint-disable-line no-restricted-syntax
        if (properties.hasOwnProperty(i) && allowedProperties.indexOf(i) === -1) {
            delete properties[i];
        }
    }

    if (properties.event) {
        $.ajax({
            type: 'POST',
            url: config.getBaseUrl() + config.get('tracking.factfinder.url'),
            data: properties,
            contentType: 'application/x-www-form-urlencoded;charset=UTF-8',
            cache: false
        });
    }
};

self.onArticleClick = function (event) {

    var $item = self.$scope.find(event.currentTarget).find('.article-container').first();
    var properties;
    var factFinderProperties = registry.get('factFinderProperties');

    /** @namespace factFinderProperties.searchQuery */
    /** @namespace factFinderProperties.pagesize */
    properties = {
        event: factFinderProperties.event,
        channel: factFinderProperties.channel,
        sid: factFinderProperties.sid,
        userId: factFinderProperties.userId,
        id: $item.data('sku'),
        masterId: $item.data('parentSku'),
        title: $item.data('title'),
        query: factFinderProperties.searchQuery,
        pos: $item.data('pos'),
        origPos: $item.data('origPos'),
        page: factFinderProperties.currentPage,
        simi: $item.data('simi'),
        pageSize: factFinderProperties.pagesize,
        origPageSize: factFinderProperties.origPageSize
    };

    storage.set(self.trackingKey, properties);
};

self.onPdpEntry = function () {

    var trackingData = storage.get(self.trackingKey);

    if (!trackingData) {
        return;
    }

    self.send(trackingData);
    storage.unset(self.trackingKey);
};

self.populateEvents = function () {
    var factFinderEvents = registry.get('factFinderEvents') || [];

    factFinderEvents.forEach((event) => {
        self.send(event);
    });
};

self.init = function () {
    if (self.$scope.find('#search-page').length > 0) {
        self.$scope.find('#category-articles').on('click', 'a.article-container', self.onArticleClick);
    } else if (self.$scope.find('#pdp-wrapper').length > 0) {
        self.onPdpEntry();
    }

    self.populateEvents();
};

self.init();

export function onArticleClick(e) {
    return self.onArticleClick(e);
}

export function send(properties) {
    return self.send(properties);
}

export function onPdpEntry() {
    return self.onPdpEntry();
}

export function init() {
    return self.init();
}



/** WEBPACK FOOTER **
 ** ./legacy/home24-desktop/tracking/factfinder.js
 **/